export enum ControlType {
  SPRINKLER_CONTROL = 'SPRINKLER_CONTROL',
}
